import React from 'react';
import logo from './logo.svg';
import { Login } from './pages/login'
import { Login2 } from './pages/login2'
import './App.css';
import "./utils/i18utils";




function App() {
  const seed = Math.random();
  console.log(`seed = $seed`);

  const startPage = seed > 0.5 ? <Login/> : <Login2/>

  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and hey to reload.
          <h1 className="text-4xl font-bold text-blue-500">Hello, Tailwind CSS!</h1>
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}


      {startPage}

    </div>
  );
}

export default App;
